import React, { Component } from "react";
import { connect } from "react-redux";
import { updateUrlTrackingApi } from "../../api/axios";
import { editOrden } from "../../actions/ordenesActions";
import PopOver from "../General/PopOver";
import MiniSpinner from "../General/MiniSpinner";
import { toast } from '../../utilities/appToast';
import PropTypes from 'prop-types';

class Entrega extends Component {
  constructor(props) {
    super(props);
    this.state = {
      urlTracking: this.getTrackingUrlFromOrden(props.orden),
      isUpdatingUrl: false
    };
  }

  componentDidUpdate(prevProps) {
    const prevId = prevProps.orden?.idOrden;
    const currId = this.props.orden?.idOrden;
    if (prevId !== currId || prevProps.orden !== this.props.orden) {
      this.setState({ urlTracking: this.getTrackingUrlFromOrden(this.props.orden) });
    }
  }

  getTrackingUrlFromOrden = (orden) => {
    const domicilio = orden?.entrega?.entregaDomicilio?.urlTracking;
    const sucursal = orden?.entrega?.entregaSucursalCorreo?.urlTracking;
    return [domicilio, sucursal].find((v) => typeof v === "string" && v.trim() !== "") || "";
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  updateUrlTracking = () => {
    const orden = this.props.orden;
    if (!orden?.idOrden) return;

    this.setState({ isUpdatingUrl: true });
    updateUrlTrackingApi({
      idVenta: orden.idOrden,
      urlTracking: this.state.urlTracking
    })
      .then(() => {
        const next = { ...orden };
        if (next?.entrega?.entregaDomicilio) {
          next.entrega.entregaDomicilio.urlTracking = this.state.urlTracking;
        }
        this.props.editOrden(next);
        toast.success("URL Tracking actualizada");
      })
      .catch((err) => {
        const errores = err?.response?.data?.errores;
        if (Array.isArray(errores)) errores.forEach((e) => toast.error(e));
        else toast.error("La URL tracking no pudo ser actualizada");
      })
      .finally(() => this.setState({ isUpdatingUrl: false }));
  };

  render() {
    const { entrega, seller } = this.props.orden;
    const { userType } = this.props;
    const canEditUrlTracking =
      seller?.envioPropio ||
      userType?.isSeller ||
      userType?.isSellerAdmin ||
      userType?.isProveedor ||
      userType?.isCategory ||
      userType?.isAdminMod;
    const urlTrackingSaved = this.getTrackingUrlFromOrden(this.props.orden);
    const {
      domicilio,
      departamento,
      piso,
      codigoPostal,
      localidad,
      provincia
    } = entrega.entregaDomicilio;

    return (
      <div className="tab-pane p-20 active" name="datos" id="home2" role="tabpanel">
        <div className="row">

          <div className="form-group col-12 col-md-6">
            <label htmlFor="calleEntrega">Calle</label>
            <input
              id="calleEntrega"   
              type="text"
              className="form-control"
              defaultValue={domicilio}
              name="calle"
            />
          </div>

          <div className="form-group col-12 col-md-6">
            <label htmlFor="departamenteEntrega">Departamento</label>
            <input
              id="departamentoEntrega"
              type="text"
              className="form-control"
              defaultValue={departamento}
            />
          </div>

          <div className="form-group col-12 col-md-6">
            <label htmlFor="pisoEntrega">Piso</label>
            <input
              id="pisoEntrega"
              type="text"
              className="form-control"
              defaultValue={piso}
            />
          </div>

          <div className="form-group col-12 col-md-6">
            <label htmlFor="codigoPostalEntrega">Codigo postal</label>
            <input
              id="codigoPostalEntrega"
              type="number"
              className="form-control"
              defaultValue={codigoPostal}
              name="codPostal"
            />
          </div>

          <div className="form-group col-12 col-md-6">
            <label htmlFor="localidadEntrega">Localidad</label>
            <input
              id="localidadEntrega"
              type="text"
              className="form-control"
              defaultValue={localidad}
              name="localidad"
            />
          </div>

          <div className="form-group col-12 col-md-6">
            <label htmlFor="provinciaEntrega">Provincia</label>
            <input
              id="provinciaEntrega"
              type="text"
              className="form-control"
              defaultValue={provincia}
              name="provincia"
            />
          </div>

          <div className="form-group col-12 col-md-6">
            <label htmlFor="tipoEntregaEntrega">Tipo de entrega</label>
            <input
              id="tipoEntregaEntrega"
              type="text"
              className="form-control"
              defaultValue={entrega.tipoEntrega.descripcion}
            />
          </div>

          <div className="col-12 mt-3">
            <div className="card border-0" style={{ boxShadow: "0 12px 28px rgba(0,0,0,0.06)", borderRadius: 16 }}>
              <div className="card-body">
                <div className="d-flex flex-wrap align-items-start justify-content-between gap-3">
                  <div>
                    <h5 className="mb-1" style={{ fontWeight: 800 }}>URL Tracking</h5>
                    <div className="text-muted" style={{ fontSize: 13 }}>
                      Seguimiento de envío de la orden.
                    </div>
                  </div>
                </div>

                <div className="mt-3 d-flex flex-wrap align-items-center gap-2">
                  {!urlTrackingSaved ? (
                    <span className="label label-grey me-1">Pendiente de envío</span>
                  ) : (
                    <a
                      id="urlTrackingEntrega"
                      href={urlTrackingSaved}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {urlTrackingSaved}
                    </a>
                  )}

                  {canEditUrlTracking && (
                    <PopOver
                      header={"¿Actualizar URL Tracking?"}
                      content={
                        <>
                          <div className="form-group">
                            <input
                              type="text"
                              name="urlTracking"
                              placeholder="URL Tracking"
                              className="form-control"
                              defaultValue={this.state.urlTracking}
                              onChange={this.handleChange}
                            />
                          </div>
                          <div className="mt-3 col-auto">
                            <button
                              type="button"
                              onClick={this.updateUrlTracking}
                              className="btn btn-sm background-rojo-megatone"
                              disabled={this.state.isUpdatingUrl}
                            >
                              Actualizar
                            </button>
                          </div>
                        </>
                      }
                    >
                      <button
                        type="button"
                        className="btn btn-light border"
                        title="Actualizar URL Tracking"
                        disabled={this.state.isUpdatingUrl}
                      >
                        <i className="fa fa-clipboard" aria-hidden="true" />
                        <span className="ms-1">Actualizar tracking</span>
                      </button>
                    </PopOver>
                  )}

                  {this.state.isUpdatingUrl && <MiniSpinner />}
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    );
  }
}
Entrega.propTypes = {
    orden: PropTypes.shape({
        entrega: PropTypes.shape({
            entregaDomicilio: PropTypes.shape({
                urlTracking: PropTypes.string,
                domicilio: PropTypes.string,
                departamento: PropTypes.string,
                piso: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
                codigoPostal: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
                localidad: PropTypes.string,
                provincia: PropTypes.string,
            }),
            tipoEntrega: PropTypes.shape({
                descripcion: PropTypes.string,
            }),
        }),
        idOrden: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        seller: PropTypes.shape({
            envioPropio: PropTypes.bool,
        }),
    }),
    editOrden: PropTypes.func,
    userType: PropTypes.shape({
      isSeller: PropTypes.bool,
      isSellerAdmin: PropTypes.bool,
      isProveedor: PropTypes.bool,
      isCategory: PropTypes.bool,
      isAdminMod: PropTypes.bool,
    }),
}

const mapStateToProps = state => ({
  orden: state.ordenes.orden,
  userType: state.general.userType
});

export default connect(mapStateToProps, { editOrden })(Entrega);